import { Box, Typography } from '@mui/material';
import {
  PRINT_FONT_SIZE,
  cellPaddingSx,
  mutedLabelTypographySx,
  valueTypographySx,
} from './printStyles';

interface JobOrderImageProps {
  imageUrl: string | null;
  alt: string;
  centerFinish: string | null;
}

const JobOrderImage = ({ imageUrl, alt, centerFinish }: JobOrderImageProps) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
    <Box
      sx={{
        position: 'relative',
        flex: 1,
        minHeight: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {imageUrl ? (
        <Box
          component="img"
          src={imageUrl}
          alt={alt}
          sx={{
            position: 'absolute',
            inset: 4,
            width: 'calc(100% - 8px)',
            height: 'calc(100% - 8px)',
            objectFit: 'contain',
          }}
        />
      ) : (
        <Typography sx={mutedLabelTypographySx}>No image</Typography>
      )}
    </Box>
    {centerFinish != null ? (
      <Box sx={{ ...cellPaddingSx, flexShrink: 0, textAlign: 'center' }}>
        <Typography sx={mutedLabelTypographySx}>Center Finish</Typography>
        <Typography
          sx={{
            ...valueTypographySx,
            fontSize: PRINT_FONT_SIZE.measurement,
            mt: 0.25,
          }}
        >
          {centerFinish}
        </Typography>
      </Box>
    ) : null}
  </Box>
);

export default JobOrderImage;
